import { v4 as uuidv4 } from 'uuid';
import environment from "./environment";
import { buildRequestWithAuth } from "~api/utils";
import { errorUnlessOk, buildRequest } from "~api/utils";
import AWS from "aws-sdk";

const fileService = (directory) => {
  return {
    upload: async (file, load, progress) => {
      const key = uuidv4();
      const fileExtension = file.name.split(".").pop();
      const fileName = `${key}.${fileExtension}`.toLowerCase();
      let request = buildRequestWithAuth("GET");
      let response = await fetch(
        `${environment.presignerUrl}/sign?key=${directory}/${fileName}&verb=put&bucket=${environment.bucketName}`,
        request
      );

      response = await errorUnlessOk(response);
      const { url } = await response.json();
      const contentType =
        file.type ||
        (fileExtension.toLowerCase() === "pdf"
          ? "application/pdf"
          : "application/octet-stream");
      fetchWithProgress(file, fileName, "put", url, load, progress, contentType);
      return fileName;
    },
    uploadPublico: async (file, load, progress) => {
      AWS.config.region = "us-east-1";
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.aws.cognitoIdentityPoolId,
      });

      const s3 = new AWS.S3();

      const key = uuidv4();
      const fileExtension = file.name.split(".").pop();
      const fileName = `${directory}/${key}.${fileExtension}`.toLowerCase();
      const params = {
        Bucket: environment.bucketName,
        Key: fileName,
        Body: file,
        ContentType:
          file.type ||
          (fileExtension.toLowerCase() === "pdf"
            ? "application/pdf"
            : "application/octet-stream"),
      };

      const managedUpload = s3.upload(params);
      managedUpload.on("httpUploadProgress", (evt) =>
        progress(evt.total != null, evt.loaded, evt.total)
      );
      // Si la subida falla, .promise() lanza y lo captura el process() de
      // FilePond, que muestra el estado de error/reintento en vez de marcar
      // el documento como cargado.
      await managedUpload.promise();
      load(fileName);
      return fileName;
    },
    delete: async (fileName) => {
      let request = buildRequestWithAuth("GET");
      let response = await fetch(
        `${environment.presignerUrl}/sign?key=${directory}/${fileName}&verb=delete&bucket=${environment.bucketName}`,
        request
      );
      response = await errorUnlessOk(response);
      const { url } = await response.json();

      const requestDelete = buildRequest("DELETE");
      response = await fetch(url, requestDelete);
      await errorUnlessOk(response);
    },

    download: async (fileName) => {
      let request = buildRequestWithAuth("GET");
      let response = await fetch(
        `${environment.presignerUrl}/sign?key=${directory}/${fileName}&verb=get&bucket=${environment.bucketName}`,
        request
      );
      const { url } = await response.json();
      const requestGet = buildRequest("GET");
      response = await fetch(url, requestGet);

      await errorUnlessOk(response);
      return response;
    },
    copy: async (source, destBucket, destObject) => {
      AWS.config.region = "us-east-1";
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: environment.aws.cognitoIdentityPoolId,
      });

      const s3 = new AWS.S3();

      var params = {
        CopySource: encodeURI(source),
        Bucket: destBucket,
        Key: destObject,
      };

      s3.copyObject(params, function (err, data) {
        if (err) throw err;
      });
    },
  };
};

const fetchWithProgress = (
  file,
  fileName,
  verb,
  url,
  load,
  progress,
  contentType = "application/octet-stream"
) => {
  var xhr = new XMLHttpRequest();
  xhr.upload.onprogress = (e) => {
    progress(e.lengthComputable, e.loaded, e.total);
  };

  xhr.open(verb, url);

  xhr.setRequestHeader("Content-Type", contentType);
  xhr.onload = (e) => {
    if (xhr.status === 200) {
      load(fileName);
    } else {
      throw Error("error at UploadFile - fetchWithProgress");
    }
  };
  xhr.onerror = (e) => {
    console.error(e);
    throw Error("error at UploadFile - fetchWithProgress");
  };
  xhr.send(file);
};

export default fileService;
